<template>
    <div>
        <el-dialog
            :title="$messageType(dialogInfo.messageType)"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :show-close="false"
            width="1000px"
            class="newIndex"
            >
            <h2 style="text-align: center;" v-html="dialogInfo.messageTitle"></h2>
            <div v-for="(item,index) in dialogInfo.courseResourceList" :key="index+'ResourceList'">
                附件下载：<el-link type="primary" :href="$isHttp(item.courseResourceUrl)" target="_blank">{{item.courseResourceName}}</el-link>
            </div>
            <div style="font-size: 18px;" class="concat_new" v-html="dialogInfo.messageConcat"></div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :disabled="byTimeShow" :loading="submitBut" @click="onSubmit">{{byTime > 0?byTime+"s 后可关闭":"关闭"}}</el-button>
            </span>
        </el-dialog>
        <el-image-viewer
            v-if="showViewer"
            :zIndex="8000"
            :on-close="closeViewer"
            :url-list="previewImgList"
            :initial-index="preIniIndex"
        />
    </div>
</template>
<script>
import {getStorageKeyForRoleTag} from "../common/ulit";
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import jQuery from 'jquery';
import { log } from "video.js";
import {ApiEncryption} from "../common/validate";
import APIDOC from '@/common/serverApi';
import {get, post} from '@/common/request';
export default {
    name: 'newIndex',
    components: { ElImageViewer },
    props: {

    },
    data() {
        return {
            dialogVisible: false,
            submitBut: false,
            byTimeShow: true,
            dialogInfo:{},
            intervalNew:null,
            byTime:5, //查看通知的倒计时

            preIniIndex: 0, // 初始化展示哪张图片
            showViewer: false, // 显示查看器
            previewImgList: []

        }
    },
    created() {
        this.getMyMessageInfo();
        this.getInterval();
    },
    methods:{
        getInterval(){
          this.intervalNew = setInterval(()=>{
              let newTime = localStorage.getItem(getStorageKeyForRoleTag("new_index_time")); //获取上一次执行获取方法的时间
              let newTag = localStorage.getItem(getStorageKeyForRoleTag("new_index_tag")); //表是已有页面展示
              if(newTag == 'OK' || this.$isEmpty(newTime) || new Date().getTime() >= Number(newTime) + (60 * 1000)){ //距离上次获取信息相差一分钟了可以继续调用
                  localStorage.setItem(getStorageKeyForRoleTag("new_index_time"),new Date().getTime());
                  this.getMyMessageInfo();
              }
          },5000);
        },
        getMyMessageInfo(index){ //获取消息详情
            this.byTime = 5;
            this.byTimeShow = true;
            let url = "/api/student/"+ApiEncryption() + "/getMessageAccept.do";
            get(window.configs.API_ROOT + url).then((ret) => {
            // this.$store.dispatch("user/getMessageAccept").then((ret) => {
            if(ret.code == 0 && !this.$isEmpty(ret.data.messageAcceptId)){
                //如果这个缓存不为空  就表示有新的消息，其他页面也赶紧显示，赶紧显示
                localStorage.setItem(getStorageKeyForRoleTag("new_index_tag"),"OK"); //表是已有页面展示
                if(this.intervalNew != null){
                    clearInterval(this.intervalNew);
                }
                this.dialogVisible = true;
                this.dialogInfo = ret.data;
                // this.dialogInfo.clearLocalVideoRecord = 1;
                // this.dialogInfo.needFlush = 1;

                //clearLocalVideoRecord = 1:就清空所有视频观看记录包括是否播放完成及播放到了多少分钟的位置(需清除包含courseInfoLog_、courselog_、courseTimeMap_的缓存)
                if(ret.data.clearLocalVideoRecord == 1){
                    const dataInfo = localStorage.valueOf();
                    for(let key in dataInfo){
                      if(
                        key.indexOf(getStorageKeyForRoleTag('courseInfoLog_')) >= 0 ||
                        key.indexOf(getStorageKeyForRoleTag('courselog_')) >= 0 ||
                        key.indexOf(getStorageKeyForRoleTag('courseTimeMap_')) >= 0
                      ){ //存在就删除
                        localStorage.removeItem(key);
                      }
                    }
                }

                let byTimeInt = setInterval(()=>{
                    this.byTime--;
                    if(this.byTime == 0){
                        this.byTimeShow = false;
                        clearInterval(byTimeInt);
                    }
                },1000);

                //绑定图片点击事件
                setTimeout(()=>{
                    let srcList = "";
                    jQuery(".concat_new img").each((i,key)=>{
                        let this_ = this;
                        srcList += jQuery(key).attr("src");
                        if(jQuery(".concat_new img").length - 1 > i){
                            srcList += ",";
                        }
                        jQuery(key).click(function(){
                            let url = jQuery(this).attr("src");
                            this_.onPreview(url);
                        });
                    });
                    this.previewImgList = srcList.split(",");
                },1000);

            }else{
                localStorage.removeItem(getStorageKeyForRoleTag("new_index_tag")); //表是已有页面展示
                console.log(ret.msg);
            }
          });
        },
        onSubmit(){ //标记已读
          this.submitBut = true;
          let url = "/api/student/"+ApiEncryption() + "/setAllAcceptState.do";
          post(window.configs.API_ROOT + url,{messageAcceptIdPlural:this.dialogInfo.messageAcceptId}).then((ret) => {
          // this.$store.dispatch("user/setAllAcceptState",{messageAcceptIdPlural:this.dialogInfo.messageAcceptId}).then((ret) => {
            if(ret.code == 0){
                this.submitBut = false;
                this.dialogVisible = false;
                localStorage.removeItem(getStorageKeyForRoleTag("new_index_tag")); //表是已有页面展示

                //needFlush = 1:就在弹出弹出框后，用户点击 关闭 的之后，刷新当前页面~
                if(this.dialogInfo.needFlush == 1){
                    this.$router.go(0);
                }else{
                    this.getInterval();
                }
            }else{
                this.$message({message: ret.msg,type: ret.code == 0?'success':"warning"});
            }
          }).catch((err) => {
            this.submitBut = false;
          });
        },
        onPreview(url) {
            this.showPreviewImg(url)
            this.showViewer = true
        },
        // 关闭查看器
        closeViewer() {
            this.showViewer = false
        },
        // 设置点击哪张图预览哪张图片方法
        showPreviewImg(url) {
            let previewImgList = this.previewImgList
            for (let index in previewImgList) {
                if (previewImgList[index] === url) {
                    this.preIniIndex = Number(index)
                    break
                }
            }
            //console.log('触发了吗')
            this.showViewer = true
        }
    }
};
</script>
<style lang="less">
    .newIndex{
        img{
            max-width: 100%;
            height: auto;
            cursor: pointer;
        }
        h2{
            p{
                margin-top: 0;
                margin-top: 0;
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/components/newIndex.vue